
import { defineComponent, ref } from "vue";
import NotificationButton from "./NotificationButton.vue";
import NotificationList from "./NotificationList.vue";

export default defineComponent({
  name: "Notification",
  components: { NotificationList, NotificationButton },
  setup() {
    const isOpened = ref(false);

    const toggleNotificationModal = () => {
      isOpened.value = !isOpened.value;
    };

    document.documentElement.addEventListener("click", (event: Event) => {
      const target = event.target as HTMLElement;
      const button = document.querySelector("[data-notification-button]");
      const list = document.querySelector("[data-notification-list]");
      const modal = document.querySelector(".modal");

      if (button?.contains(target)) {
        toggleNotificationModal();
      } else if (!list?.contains(target) && !modal?.contains(target)) {
        isOpened.value = false;
      }
    });

    return {
      isOpened,
      toggleNotificationModal,
    };
  }
});
